/**
 * creator:
 * date: 2021/6/16 下午3:36:46
 * path:
 * description:
 * @link:
 */
import React from 'react';
import { Route, Switch } from 'react-router-dom';
import Loadable from 'react-loadable';
import { Loading } from 'components';

const Spin = () => <Loading loading />;

const Main = Loadable({
	loader: () => import('./main.js'),
	loading: Spin,
});

const MallSettingEdit = Loadable({
	loader: () => import('./routes/edit'),
	loading: Spin,
});

export default ({ match }) => {
	return (
		<Switch>
			<Route path= {`${match.url}/edit`} component={MallSettingEdit} />
			<Route path= {match.url} component={Main} />
		</Switch>
	);
};
